export default __webpack_public_path__ + "static/media/html5.d0addc05.svg";